export enum Role {
  installer = "installer",
  admin = "admin",
  superAdmin = "super_admin",
}
